// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FU3oSV{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}.FU3oSV:hover{opacity:.7}.yEp4AX{visibility:hidden !important;width:0 !important;min-width:0 !important;height:0 !important;min-height:0 !important;margin:0 !important;padding:0 !important;opacity:0 !important}.MzwjnI{display:flex;flex:0 0 auto;height:25px;align-items:center}.KsmM_T{font-size:12px;line-height:12px}[data-playable-hook='player-container'][data-playable-in-full-screen=\"true\"] .KsmM_T{font-size:14px;line-height:14px}.PDXv4j{margin-left:5px}.PDXv4j:before{margin-right:4px;content:'/'}.ut4LAi .QCxkkL{display:none}.ut4LAi .PDXv4j{display:none}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controlButton": "FU3oSV",
	"hidden": "yEp4AX",
	"timeWrapper": "MzwjnI",
	"time": "KsmM_T",
	"duration": "PDXv4j",
	"liveMode": "ut4LAi",
	"separator": "QCxkkL"
};
export default ___CSS_LOADER_EXPORT___;
